import { useEffect, useState } from 'react';
const printMediaQuery = window.matchMedia('print');
function useMatchMedia(query) {
  const [matches, setMatches] = useState(() => window.matchMedia(query).matches);
  useEffect(() => {
    const handleResize = () => {
      setMatches(window.matchMedia(query).matches);
    };
    window.addEventListener('resize', handleResize);
    printMediaQuery.addListener(handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
      printMediaQuery.removeListener(handleResize);
    };
  }, [query]);
  return matches;
}
export default useMatchMedia;